import React from 'react';

// eslint-disable-next-line max-len
const MOONBOOTS_LOGO = '/themes/theme/moonboots/logo.png';
const MOONBOOTS_DARK_LOGO = '/themes/theme/moonboots/logo-dark.png';

const MOONBOOTSTheme = {
  headerLogo: {
    src: MOONBOOTS_DARK_LOGO,
    alt: 'MOONBOOTS Logo',
    size: 70,
  },
  darkLogo: {
    src: MOONBOOTS_DARK_LOGO,
    alt: 'MOONBOOTS Logo',
    size: 70,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #000000',
    height: 80,
  },
  title: 'MOONBOOTS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src={MOONBOOTS_DARK_LOGO} alt="MOONBOOTS Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.mymoonboots.io',
};

export default MOONBOOTSTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/moonboots.js
 **/